/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { TreeItem, TreeView } from "@mui/lab";
import { useLoaderData, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SyncIcon from "@mui/icons-material/Sync";

import useGetPageInfo from "../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import { toJalaliFullDate } from "../../../middleware/middleware";

const getTreeItemsFromData = (treeItems, parentId, level) => {
  return treeItems.map((treeItemData) => {
    let children;
    let list =
      treeItemData.substationList ||
      treeItemData.transList ||
      treeItemData.feederList;

    if (list && list.length > 0) {
      children = getTreeItemsFromData(
        list,
        `${parentId}-${treeItemData.id}`,
        level + 1
      );
    }

    return (
      <TreeItem
        key={`${parentId}-${treeItemData.id}`}
        nodeId={`${parentId}-${treeItemData.id}`}
        label={
          treeItemData.cityName ||
          treeItemData.substationName ||
          treeItemData.transNumber ||
          treeItemData.feederName
        }
        children={children}
      />
    );
  });
};

const onGetChildIds = (node, prev) => {
  let list = node.substationList || node.transList || node.feederList;

  if (list?.length > 0) {
    let ids = [];
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      ids = [
        ...ids,
        `${prev}-${node.id}`,
        ...onGetChildIds(item, `${prev}-${node.id}`),
      ];
    }
    return ids;
  } else {
    return [];
  }
};

const onFindNodeId = (list, ids) => {
  const currentId = ids[0];
  const otherIds = ids.slice(1);
  if (list.length > 0) {
    const item = list.find((x) => x.id == currentId);
    if (item) {
      if (otherIds.length > 0) {
        let children = item.substationList || item.transList || item.feederList;
        return [item, ...onFindNodeId(children, otherIds)];
      } else {
        return [item];
      }
    }
  }

  return null;
};

const GridTreePage = () => {
  let navigate = useNavigate();
  const pageInfo = useGetPageInfo();
  const data = useLoaderData("root");
  const [content, setContent] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState([]);

  const onFetchData = () => {
    navigate();
  };

  const onNodeSelect = (e, nodeId) => {
    const ids = nodeId.split("-");
    setSelected([nodeId]);
    const node = onFindNodeId(data.cityList, ids.slice(1));
    if (node) {
      setContent(node);
    } else {
      setContent([]);
    }
  };

  const onNodeFocus = (e, nodeId) => {
    const ids = nodeId.split("-");

    let finalList = [];
    if (expanded.find((x) => x === nodeId)) {
      finalList = expanded.filter((node) => node !== nodeId);
    } else {
      if (ids.length === 2) {
        const node = data.cityList.find((x) => x.id == ids[1]);
        const childIds = onGetChildIds(node, ids[0]);
        finalList = [...childIds];
      } else finalList = [...expanded, nodeId];
    }

    setExpanded(finalList);
  };

  return (
    <Grid container spacing={3} className="gv-view-container ">
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title || "درخت شبکه"}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 2,
                    height: "70vh",
                    overflow: "auto",
                    boxShadow: "0px 12px 21px 2px rgba(218, 230, 249, 0.4)",
                  }}
                >
                  <TreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronLeftIcon />}
                    selected={selected}
                    onNodeSelect={onNodeSelect}
                    expanded={expanded}
                    onNodeFocus={onNodeFocus}
                    className="tree-view-container"
                  >
                    {getTreeItemsFromData(data.cityList, "node", 0)}
                  </TreeView>
                </Paper>
              </Grid>
              <Grid item xs={12} md={8}>
                {content.length > 0 &&
                  content.map((info) => {
                    // console.log("info", info);

                    if (info.substationName) {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={12}
                          container
                          sx={{ mb: 4 }}
                          className="custom-table"
                        >
                          <Grid item xs={12} md={12} className="row header">
                            <Typography fontWeight={"bold"} color={"primary"}>
                              ایستگاه
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                نام ایستگاه
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.substationName}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد دیسپاچینگ
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.substationDispatchingCode}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد IGMC
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.substationIGMCCode}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد GIS
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.substationGISCode}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد قدیمی GIS
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {/* {info.companyName} */}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                نوع ایستگاه{" "}
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.substationKind}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                مالکیت ایستگاه
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.company}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                شهرستان
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.city}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                ظرفیت MVA
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.substationTotalCapacity}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                تعداد ترانس
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {/* {info.companyName} */}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                تعداد فیدر
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {/* {info.companyName} */}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                تعداد DG
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {/* {info.companyName} */}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                درصد اختلاف ورودی/خروجی
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.percentInOutDiff}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                شروع بهره برداری
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {toJalaliFullDate(info.substationActDate)}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    }

                    if (info.transNumber) {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={12}
                          container
                          className="custom-table"
                          sx={{ mb: 4 }}
                        >
                          <Grid item xs={12} md={12} className="row header">
                            <Typography fontWeight={"bold"} color={"primary"}>
                              ترانس
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                شماره ترانس
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.transNumber}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد مدیریت شبکه
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.transIGMCCode}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد GIS
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.transGISCode}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                ظرفیت ترانس (MVA)
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.transCapacity}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                شروع بهره برداری
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {toJalaliFullDate(info.transActDate)}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                پایان بهره برداری
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {toJalaliFullDate(info.transDismandDate)}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    }

                    if (info.feederName) {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={12}
                          container
                          className="custom-table"
                        >
                          <Grid item xs={12} md={12} className="row header">
                            <Typography fontWeight={"bold"} color={"primary"}>
                              فیدر
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                شماره فیدر
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.feederName}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                نوع فیدر
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.feederKind}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد مدیریت شبکه
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.feederIGMCCode}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                کد GIS
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.feederGeoCode}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                حداکثر مقدار مجاز:
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.maxRange}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                حداقل مقدار مجاز
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.minRange}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                مالکیت
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.ownerCompany}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                تعداد DG
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {/* {info.companyName} */}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                سریال کنتور
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {/* {info.companyName} */}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                درصد خانگی
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.percentHouseholds}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                درصد صنعتی
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.percentIndustrial}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                درصد کشاورزی
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.percentAgriculture}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                درصد عمومی
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.percentPublic}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                درصد سایر
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {info.percentOther}
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={12} className="row" container>
                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                شروع بهره برداری
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {toJalaliFullDate(info.feederActDate)}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={6} container>
                              <Grid item xs={6} md={6} className="cell title">
                                پایان بهره برداری
                              </Grid>
                              <Grid item xs={6} md={6} className="cell value">
                                {toJalaliFullDate(info.feederDismandDate)}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    }

                    return null;
                  })}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default GridTreePage;
